@switch (query.status()) {
  @case ('pending') {
    <mat-card appearance="outlined">
      <mat-card-content>
        <fz-skeleton-table></fz-skeleton-table>
      </mat-card-content>
    </mat-card>
  }

  @case ('error') {
    <mat-card appearance="outlined">
      <mat-card-content>
        My apologies, there was an error fetching your game history. Please try
        again later.
        <button mat-raised-button color="primary" (click)="query.refetch()">
          Try Again
        </button>
      </mat-card-content>
    </mat-card>
  }

  @default {
    <fz-history-list-table
      [loggedIn]="true"
      [loading]="false"
      (pageChange)="onGameHistoryPageChange($event)"
      [gameHistory]="query.data()?.matchResultsForUser || []"
      [totalGameHistory]="query.data()?.total || 10"
      (tryFree)="handleTryForFree()"
      [level]="'tournament'"
      class="history-component"
    >
    </fz-history-list-table>
  }
}
